import React, { useEffect, useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../helpers/form/FormHelper'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../helpers/form/FormData'
import GoodTypeSelectMain from '../../../form/fields/GoodTypeSelectMain'
import GoodSelectMain from '../../../form/fields/GoodSelectMain'
import MyButton from '../../../UI/form/MyButton'
import { addGoodInBoxAPI } from '../../../../api/pack/seriesAPI'

const BoxSeriesForm = ({ boxId, seriesBd, setOpen }) => {

    const [data, setData] = useState({}) // Дані з форми

	const [valid, setValid] = useState({}) // Валідація кожного поля
	const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState('')

	useEffect(() => {
		checkValid(valid, setIsValidForm)
	}, [valid])

	const add = () => {
		setLoading(true)
		setError('')
		addGoodInBoxAPI({ 
			boxId, 
            // seriesId: seriesBd.id,
			goodTypeId: data.goodTypeId,
			goodId: data.goodId
		}).then(data => {
			setOpen(false)
			setLoading(false)
		}).catch(e => {
			setError(responseError(e))
			setLoading(false)
		})
	}

  return (
    <div className='myFormSimple'>
		<div>
			<p>Будьте уважні, що немає обмежень на додавання нових товарів в коробку поштучно.</p>
			<p>При додаванні нового товару треба на 100% розуміти, що він має бути в цій коробці</p>
		</div>

		{
			formDataProductIsField('goodTypeId', 'goodInBox') ?
				<GoodTypeSelectMain
					required={formDataProductRequiredField('goodTypeId', 'goodInBox')}
					setValidate={e => updateValidate(setValid, 'goodTypeId', e)}
					setValueForm={e => setValueForm(setData, 'goodTypeId', e)}
					forciblyValue={data && data.goodTypeId ? data.goodTypeId : ''}
				/>
			: ''
        }
		{
			formDataProductIsField('goodId', 'goodInBox') ?
				<GoodSelectMain
					goodTypeId={data && data.goodTypeId ? data.goodTypeId : null}
					required={formDataProductRequiredField('goodId', 'goodInBox')}
					setValidate={e => updateValidate(setValid, 'goodId', e)}
					setValueForm={e => setValueForm(setData, 'goodId', e)}
					forciblyValue={data && data.goodId ? data.goodId : ''}
				/>
			: ''
        }

        {
			error ?
				<div className='error'>
					{ error }
				</div>
			: ''
		}

        <MyButton
            size='md'
            onClick={add}
            disabled={!isValidForm || loading ? true : false}
        >
            Додати товари
        </MyButton>
    </div>
  )
}

export default BoxSeriesForm